import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHelpersService } from '../http-helpers/http-helpers.service';
import { Response } from 'src/app/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class RequestCreationService {

  private subject = new Subject<void>();
  private url: string;

  constructor(
    private http        : HttpClient,
    private utils       : UtilsService,
    private httpHelpers : HttpHelpersService,
    private translate : TranslateService
  ) {
    this.url = this.httpHelpers.getUrl();
  }

  getEnclosures(company, unitParams, page, q?): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader(),
      ...this.httpHelpers.setParams(
        {
          'pagination[rowsPerPage]': 20,
          'pagination[page]': page || 1,
          'q': q || '',
          'empresa': unitParams.company,
          'propiedad': unitParams.selectedUnitId
        }
      ),
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.get<Response>(`${this.url}/empresas/${company}/estructura/recintos`,
      httpOptions)
      .pipe(map((data) => {

        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.obtener recintos')))
      );
  }

  getItemsSpots(company, enclosureId, page, unitParams, q?): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader(),
      ...this.httpHelpers.setParams(
        {
          'pagination[rowsPerPage]': 20,
          'pagination[page]': page || 1,
          'propiedad': unitParams.selectedUnitId,
          'q': q || ''
        }
      ),
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.get<Response>(`${this.url}/empresas/${company}/estructura/recintos/${enclosureId}/items`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.obtener items y lugares')))
      );
  }

  getFailureDetail(company, enclosureId, itemId, page, unitParams, q?): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.setParams(
        {
          'item_id': itemId,
          'pagination[rowsPerPage]': 20,
          'pagination[page]': page || 1,
          'propiedad': unitParams.selectedUnitId,
          'q': q || ''
        }),
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.get<Response>(`${this.url}/empresas/${company}/estructura/recintos/${enclosureId}/items/${itemId}/detalles`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.obtener detalles de falla')))
      );
  }

  getFailureDetailByEnclosureSpotItem(company, enclosureId, spotId, itemId, page, unitParams, q?): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.setParams(
        {
          // 'item_id': itemId,
          // 'lugar_id': spotId,
          'pagination[rowsPerPage]': 20,
          'pagination[page]': page || 1,
          'propiedad': unitParams.selectedUnitId,
          'q': q || ''
        }),
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.get<Response>(`${this.url}/empresas/${company}/estructura/recintos/${enclosureId}/lugares/${spotId}/items/${itemId}/detalles`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.obtener detalles de falla')))
      );
  }


  getS3PreSignedUrl(imageName, mimeType): Observable<any> {
    const fd = new FormData();
    fd.append('key', imageName);
    fd.append('contentType', mimeType);

    const httpOptions = {
      ...this.httpHelpers.getHeader(),
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.post<any>(`${this.url}/s3/pre-signed-url`, fd, httpOptions).pipe(map((data) => {
      return data
    }),
      catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.obtener credenciales')))
    );
  }

  async uploadImageToS3FromApp(filePath, s3Response): Promise<any> {
    // return new Promise(async (res, rej) => {
    //   const fileTransfer: FileTransferObject = this.transfer.create();
    //   let params = {};
    //   for (const key in s3Response.fields) {
    //     params[key] = s3Response.fields[key]
    //   }

    //   let options: FileUploadOptions = {
    //     fileKey: 'file',
    //     fileName: s3Response.path,
    //     httpMethod: 'POST',
    //     headers: {
    //       connection: "close"
    //     },
    //     chunkedMode: false,
    //     params
    //   }

    //   try {
    //     await fileTransfer.upload(filePath, s3Response.action, options);
    //     res();
    //   } catch (e) {
    //     rej();
    //   }
    // })
  }

  uploadImageToS3FromWeb(s3Response, file) {
    const fd = new FormData()

    for (const key in s3Response.fields) {
      fd.append(key, s3Response.fields[key])
    }
    fd.set('file', file);
    return this.http.post<any>(s3Response.action, fd)
      .pipe(map((data) => data),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.subir archivo')))
      );
  }

  uploadImageToS3(url, image): Observable<any> {
    return this.http.put(url, image).pipe(
      catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.subir archivo')))
    );
  }


  createRequest(company, property, request): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader(),
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.post<any>(`${this.url}/empresas/${company}/propiedades/${property}/solicitudes`, request, httpOptions)
      .pipe(map(({ data }) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('request-creation.crear solicitud')))
      );
  }

  updateFiles() {
    this.subject.next();
  }

  getFilesAvailability(): Observable<any> {
    return this.subject.asObservable();
  }

}
